<div class="row justify-content-around">
  <h2 class="col-12 mat-button mat-primary">Vos Avantage</h2>
  <div class="col-sm-4 ">
      <div class="row">
          <div class="col-12 mat-button mat-primary">
              <h4>Des voitures agréables</h4>
          </div>
          <div class="col-12">
              <p>
                  Des voitures électriques confortables et bien entretenues.
    
                  Des voitures électriques confortables et bien entretenues.
              </p>
          </div>
      </div>   
    </div>
    <div class="col-sm-4 ">
        <div class="row">
            <div class="col-12 mat-button mat-primary">
                <h4>Des voitures agréables</h4>
            </div>
            <div class="col-12">
                <p>
                    Des voitures électriques confortables et bien entretenues.
                </p>
            </div>
        </div>   
      </div>
      <div class="col-sm-4 ">
          <div class="row">
              <div class="col-12 mat-button mat-primary">
                  <h4>Des voitures agréables</h4>
              </div>
              <div class="col-12">
                  <p>
                      Des voitures électriques confortables et bien entretenues.
                  </p>
              </div>
          </div>   
        </div>
        <div class="col-sm-4 ">
            <div class="row">
                <div class="col-12 mat-button mat-primary">
                    <h4>Des voitures agréables</h4>
                </div>
                <div class="col-12">
                    <p>
                        Des voitures électriques confortables et bien entretenues.
                    </p>
                </div>
            </div>   
          </div>
      
</div>